import axios from "axios";
const API_URL = process.env.REACT_APP_API;

export async function getActivityLog(createdAt: string, collaborator_id: number) {
    try {
        const params = new URLSearchParams();

        if (createdAt) params.append('createdAt', createdAt);
        if (collaborator_id) params.append('collaborator_id', collaborator_id.toString())

        const response = await axios.get(`${API_URL}activity/log?${params.toString()}`);
        const data = response.data.doc.data;
        return data;
    } catch (err) {
        console.error("Error al actualizar el precio:", err);
        throw err;
    }
}